import { DrawerBodyStyles, DrawerBodyTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { DrawerBody } from "./drawer-body.js";
/**
 * The Fabric Drawer Body component.
 *
 * @public
 */
export const definition = DrawerBody.compose({
    name: `${DesignSystem.prefix}-drawer-body`,
    template: DrawerBodyTemplate,
    styles: DrawerBodyStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=drawer-body.definition.js.map